<template>
  <form @submit.prevent="buscaLog()" autocomplete="off">
    <b-row>
      <b-col cols="12">
        <div class="titlePage mb-3">Logs</div>
      </b-col>
      <b-col cols="6">
        <fcc-input v-model="campoBusca" v-mask="'#########'" required>Nº Pedido</fcc-input>
      </b-col>
      <b-col cols="2">
        <fcc-button icon="search" tipo="submit" class="mb-3"> Buscar </fcc-button>
      </b-col>
      <b-col cols="12">
        <fccTable
          striped
          hover
          :fields="fieldsLogs"
          :orderby="sortBy"
          :items="lstLogs"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
        />
      </b-col>
    </b-row>
  </form>
</template>
  <script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      permissao: null,
      tipo: true,
      titlePage: 'Logs',
      campoBusca: '',
      lstLogs: [],
      sortBy: 'datainicio',
      itemPorPage: '200',
      fieldsLogs: [
        { key: 'cpf', label: 'CPF', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'spi', label: 'SPI', sortable: true },
        { key: 'numpedido', label: 'Nº Pedido' },
        { key: 'fase', label: 'Fase' },
        { key: 'datainicio', label: 'Data' }
      ]
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
  },
  methods: {
    buscaLog() {
      this.lstLogs = []
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `Publicacao/ListarHistoricoAcessoCandidatoFases/${this.campoBusca}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstLogs = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>
  